import React, { useEffect, useState } from "react";
import strings from "translate/language";
import { useDispatch, useSelector } from "react-redux";
import {
  handleListResponse,
  mobileNumberValid,
  pancardValidation,
  seo,
  validateAadhaar,
  emailAddressValid,
  minORmaxAmountEmiValid,
  isEmpty,
  nameValid,
  minORmaxValid,
} from "utils/utils";
import {
  addVisitor,
  addVisitProperty,
  removeVistor,
} from "reduxStore/action/visitorActions";
import {
  ClosingManager,
  ClosingTL,
  SourcingManager,
  SourcingTL,
  closing_head_id,
  referenceMaster,
  channelPartnerMaster,
  SourcingHead,
  directWalkinMaster,
  exhibitionMaster,
  referralPartnerMaster,
} from "utils/constants";
import { getUserDetailForVisitor } from "reduxStore/action/usersActions";
import { getAgentProperty } from "reduxStore/action/propertyActions";
import { jwtTokenGenrate } from "reduxStore/action/authActions";
import { setDefaultHeader } from "../../utils/httpClient";
import {
  getConfiguration,
  getEthnicity,
} from "reduxStore/action/masterActions";
import { getMasterList } from "reduxStore/action/masterActions";

const Lead = () => {
  const [form, setForm] = useState({});
  const [formVaild, setFormVaild] = useState(null);
  const [apiResponse, setApiResponse] = useState([]);
  const [successPop, setSuccessPop] = useState(false);
  const dispatch = useDispatch();
  const [configurationsType, setConfigurationsType] = useState([]);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [ethnicityList, setEthnicityList] = useState([]);
  
  // const [leadSourceType, setleadSourceType] = useState([]);
  // const leadSourceSelector = useSelector((state) => state.masterData);

  const configurationsSelector = useSelector((state) => state.configurations);
  const ethnicitySelector = useSelector((state) => state.ethnicitys);

  const visitorLeadSelector = useSelector((state) => state.visitor);
  const propertySelector = useSelector((state) => state.propertyData);
  const authGenerate = useSelector((state) => state.login);
  const params = new URLSearchParams(window.location.search);
  const userData = useSelector((state) => state.userData);
  const userId = params.get("user_id");

  const userDetails = userData?.userDetails?.data;

  const roleId = userDetails?.role_id;
  // const result = handleDetailResponse(authGenerate.data);

  useEffect(() => {
    if (visitorLeadSelector.create === true) {
      if (visitorLeadSelector.response?.status === 200) {
        dispatch(removeVistor());
        setSuccessPop(true);
        setForm({});
      }
    }
  }, [dispatch, visitorLeadSelector]);

  useEffect(() => {
    dispatch(jwtTokenGenrate());
  }, [dispatch]);

  useEffect(() => {
    if (userId && !userData?.userDetails) {
      // Make sure the user data is not already available
      dispatch(getUserDetailForVisitor({ user_id: userId }));
    }
  }, [dispatch, userId, userData?.userDetails]); // Depend on userId and userData

  useEffect(() => {
    if (ethnicitySelector.response) {
      const { response } = ethnicitySelector;
      if (response?.status === 200) {
        const filteredEthnicitys = response.data;
        setEthnicityList(filteredEthnicitys);
      } else {
        setEthnicityList([]);
      }
    }
  }, [ethnicitySelector]);

  useEffect(() => {
    if (authGenerate.response) {
      if (authGenerate.response.status === 200) {
        setDefaultHeader("token", authGenerate.response.token);
        if (userId) {
          dispatch(getAgentProperty({ user_id: userId }));
          dispatch(getConfiguration());
          dispatch(getMasterList({ type: 13 }));
          dispatch(getEthnicity({ type: 15 }));
        }
      }
    }
  }, [dispatch, authGenerate, userId]);

  useEffect(() => {
    if (!userId) {
      window.location.assign("/error-404.html");
    }
  }, [userId]);

  useEffect(() => {
    const { response } = propertySelector;
    if (response && response.status === 200) {
      setApiResponse(handleListResponse(response?.data) ? response?.data : []);
    } else {
      setApiResponse([]);
    }
  }, [propertySelector]);

  useEffect(() => {
    if (configurationsSelector.response) {
      const { response } = configurationsSelector;
      if (response?.status === 200) {
        setConfigurationsType(handleListResponse(response.data));
      } else {
        setConfigurationsType([]);
      }
    }
  }, [configurationsSelector]);


  // useEffect(() => {
  //   if (leadSourceSelector.response) {
  //     const { response } = leadSourceSelector;
  //     if (response?.status === 200) {
  //       let filteredData = response.data;
  //       if (
  //         userDetails?.rom &&
  //         [SourcingHead, SourcingManager, SourcingTL].includes(roleId)
  //       ) {
  //         // For SourcingManager and SourcingTL, only Channel Partner and Reference should be included
  //         filteredData = filteredData.filter((item) =>
  //           [
  //             channelPartnerMaster,
  //             directWalkinMaster,
  //             exhibitionMaster,
  //             referralPartnerMaster,
  //             referenceMaster,
  //           ].includes(item._id)
  //         );
  //       } else if (
  //         [SourcingHead, SourcingManager, SourcingTL].includes(roleId)
  //       ) {
  //         // For SourcingManager and SourcingTL, only Channel Partner and Reference should be included
  //         filteredData = filteredData.filter((item) =>
  //           [channelPartnerMaster, referralPartnerMaster].includes(item._id)
  //         );
  //       } else if (
  //         [ClosingManager, ClosingTL, closing_head_id].includes(roleId)
  //       ) {
  //         // For ClosingManager and ClosingTL, exclude Channel Partner and Reference
  //         filteredData = filteredData.filter(
  //           (item) =>
  //             ![channelPartnerMaster, referralPartnerMaster].includes(item._id)
  //         );
  //       }

  //       setleadSourceType(handleListResponse(filteredData));
  //     } else {
  //       setleadSourceType([]);
  //     }
  //   }
  // }, [leadSourceSelector, roleId, userDetails?.rom]);

  const handlePropertySelect = (e) => {
    const selectedPropertyId = e.target.value;
    setSelectedProperty(selectedPropertyId); // Set selected property
    const selectedPropertyData = apiResponse.find(
      (item) => item.property_id === selectedPropertyId
    );

    // If the selected property has configurations, update the state
    if (selectedPropertyData && selectedPropertyData.configurations) {
      setConfigurationsType(selectedPropertyData.configurations); // Set configurations based on property
    } else {
      setConfigurationsType([]); // Clear configurations if none are found
    }

    // Update form state with the selected property
    setForm({
      ...form,
      property_id: selectedPropertyId,
      configuration_id: "", // Reset configuration when property is changed
      configuration: "",
    });
  };

  // Handle configuration selection
  const handleConfigurationSelect = (e) => {
    const configurationId = e.target.value;
    const selectedConfiguration = configurationsType.find(
      (config) => config._id === configurationId
    );
    setForm({
      ...form,
      configuration_id: configurationId,
      configuration: selectedConfiguration ? selectedConfiguration.title : "",
    });
  };

  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]:
        e.target.name === "adhar_no"
          ? e.target.value
              .replace(/\D/g, "")
              .split(/(?:([\d]{4}))/g)
              .filter((s) => s.length > 0)
              .join(" ")
          : e.target.value,
    };
    setForm(nextFormState);
  };

  const handleSubmit = () => {
    if (!handleValid()) {
      const formData = new FormData();
      userId && formData.append("user_id", userId);
      formData.append("acquisition_source", 2); // for use backed side manage
      form.configuration &&
      formData.append("configuration", form.configuration);
      form.configuration_id &&
      formData.append("configuration_id", form.configuration_id);
      form.purpose && formData.append("purpose", form.purpose);
      form.first_name && formData.append("first_name", form.first_name);
      formData.append("country_code", "+91");
      form.mobile && formData.append("mobile", form.mobile);
      form.email && formData.append("email", form.email);
      form.gender && formData.append("gender", form.gender);
      form.occupation && formData.append("occupation", form.occupation);
      form.property_id && formData.append("property_id", form.property_id);
      // formData.append("referrel_partner",2)
      formData.append("draft", "true");
      form.ethnicity &&
      formData.append("ethnicity", form.ethnicity);
      form.ethnicity_id &&
      formData.append("ethnicity_id", form.ethnicity_id);
      form.visit_with &&
      formData.append("visit_with", form.visit_with);
      form.expected_possession_period &&
      formData.append("expected_possession_period", form.expected_possession_period);
      form.budget_amount &&
      formData.append("budget_amount", form.budget_amount);
      form.location && formData.append("location", form.location);
      form.office_address &&
      formData.append("office_address", form.office_address);

    if (isEmpty(form.property_id)) {                
        dispatch(addVisitProperty(formData));
      } else {
        dispatch(addVisitor(formData));
      }
    }
  };
  const handleValid = () => {
    let err = {};
    let formError = false;
    if (!form.first_name) {
      formError = true;
      err["first_name"] = strings.firstName_Err;
    } else if (!nameValid(form.first_name)) {
      formError = true;
      err["first_name"] = strings.nameValidErr;
    }
    if (!form.mobile) {
      formError = true;
      err["mobile"] = strings.mobileErr;
    } else if (!mobileNumberValid(form.mobile)) {
      formError = true;
      err["mobile"] = strings.mobileValidErr;
    }
    if (!form.gender) {
      formError = true;
      err["gender"] = strings.genderErr;
    }
    if (!form.property_id) {
      formError = true;
      err["property"] = strings.propertyRequire;
    }
    if (form.whatsapp_no && !mobileNumberValid(form.whatsapp_no)) {
      formError = true;
      err["whatsapp_no"] = strings.mobileValidErr;
    }
    if (form.adhar_no && !validateAadhaar(form.adhar_no)) {
      formError = true;
      err["adhar_no"] = strings.validAadhar_Err;
    }
    if (form.pancard_no && !pancardValidation(form.pancard_no)) {
      formError = true;
      err["pancard_no"] = strings.validPancard_Err;
    }
    if (form.email && !emailAddressValid(form.email)) {
      formError = true;
      err["email"] = strings.emailValidationErr;
    }
    if (minORmaxValid(form.min_emi_budget, form.max_emi_budget) === 1) {
      formError = true;
      err["emiAmountErr"] = strings.amountMaxEmiEror;
    }
    if (minORmaxValid(form.min_emi_budget, form.max_emi_budget) === 2) {
      formError = true;
      err["emiAmountErr"] = strings.amountMinEmiEror;
    }
    if (
      !minORmaxAmountEmiValid(
        form.min_emi_budget,
        form.max_emi_budget,
        form.min_emi_budget_type,
        form.max_emi_budget_type
      )
    ) {
      formError = true;
      err["emiAmountErr"] = strings.amountEror;
    }
    setFormVaild(err);
    return formError;
  };

  useEffect(() => {
    seo({
      title: "Create Lead",
      metaDescription: "create lead",
      canonicalLink: window.location.href,
    });
  }, []);

  // console.log("Api", apiResponse);

  return userId ? (
    <div className="page-body">
      {/* Model_start */}
      {successPop ? (
        <div
          className="modal show"
          tabIndex="-1"
          style={{
            display: "block",
          }}
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-body">
                <img
                  src="assets/images/success.gif"
                  alt=""
                  style={{ width: "100%" }}
                />
                <h5 className="text-center pt-3">{strings.thankYou}</h5>
                <h5 className="text-center">{strings.visitSubmitted}</h5>
              </div>

              <div
                style={{
                  justifyContent: "center",
                  display: "flex",
                  padding: "15px",
                }}
              >
                <button
                  className="btn btn-color"
                  type="button"
                  onClick={() => {
                    setSuccessPop(false);
                    window.location.reload();
                  }}
                >
                  {strings.done}
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {/* Model_end */}
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12 ">
            <div className="card">
              <form className="form theme-form">
                <div className="card-body">
                  <h5 className="text-center">{strings.visitorDetails}</h5>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlFirstName">
                          {strings.visitorFullName}
                          <span className="required-field"></span>
                        </label>
                        <input
                          className="form-control"
                          id="exampleFormControlFirstName"
                          type="text"
                          name="first_name"
                          value={form.first_name}
                          placeholder={strings.visitorFullName}
                          onChange={handleInputField}
                          autoComplete="off"
                        />
                        {formVaild?.first_name && (
                          <span style={{ color: "red" }}>
                            {formVaild?.first_name}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label htmlFor="exampleInputMobileNo">
                          {strings.mobileNo}
                          <span className="required-field"></span>
                        </label>
                        <input
                          className="form-control"
                          id="exampleInputMobileNo"
                          type="number"
                          maxLength={10}
                          name="mobile"
                          value={form.mobile}
                          placeholder={strings.mobileNo}
                          autoComplete="off"
                          onChange={(event) => {
                            if (event.target.value.length <= 10) {
                              handleInputField(event);
                            }
                          }}
                        />
                        {formVaild?.mobile && (
                          <span style={{ color: "red" }}>
                            {formVaild?.mobile}
                          </span>
                        )}
                      </div>
                    </div>          

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlLastName">
                          {strings.propertyname}
                          <span className="required-field"></span>
                        </label>
                        <select
                          className="form-control digits"
                          id="formcontrol-select1"
                          name="property_id"
                          value={form.property_id}
                          onChange={handlePropertySelect}
                        >
                          <option defaultValue={null}>
                            {strings.selectProp}
                          </option>
                          {apiResponse &&
                            apiResponse.map((item, index) => (
                              <option key={index} value={item.property_id}>
                                {item.property_title}
                              </option>
                            ))}
                        </select>
                        {formVaild?.property && (
                          <span style={{ color: "red" }}>
                            {formVaild?.property}
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-2">
                        <label htmlFor="exampleFormControlLastName">
                          {strings.gender}
                          <span className="required-field"></span>
                        </label>
                        <div className="col-md-12 form-group m-t-3 m-checkbox-inline mb-0 custom-radio-ml">
                          <div className="radio radio-primary col-md-4">
                            <input
                              id="radioLine11"
                              className="form-check-input"
                              type="radio"
                              name="gender"
                              value={1}
                              checked={Number(form.gender) === 1 ? true : false}
                              onChange={handleInputField}
                            />
                            <label className="mb-0" htmlFor="radioLine11">
                              {strings.male}
                            </label>
                          </div>
                          <div className="radio radio-primary col-md-4 mt-1">
                            <input
                              id="radioLine22"
                              className="form-check-input"
                              type="radio"
                              name="gender"
                              value={2}
                              checked={Number(form.gender) === 2 ? true : false}
                              onChange={handleInputField}
                            />
                            <label className="mb-0" htmlFor="radioLine22">
                              {strings.female}
                            </label>
                          </div>
                        </div>
                      </div>
                      {formVaild?.gender && (
                        <span className style={{ color: "red" }}>
                          {formVaild?.gender}
                        </span>
                      )}
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label htmlFor="exampleInputMobileNo">
                          {strings.emailAddress}
                        </label>
                        <input
                          className="form-control"
                          autoComplete="off"
                          id="exampleInputMobileNo"
                          type="email"
                          name="email"
                          value={form.email}
                          placeholder={strings.emailaddress}
                          onChange={handleInputField}
                        />
                        {formVaild?.email && (
                          <span style={{ color: "red" }}>
                            {formVaild?.email}
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label htmlFor="exampleInputMobileNo">
                          {strings.residentLocation}
                        </label>
                        <input
                          className="form-control"
                          id="exampleInputMobileNo"
                          placeholder={strings.location}
                          value={form.location}
                          onChange={handleInputField}
                          name="location"
                          type="text"
                          autoComplete="off"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlInput1">
                          {strings.workLocation}
                        </label>
                        <input
                          className="form-control"
                          id="exampleFormControlInput1"
                          type="text"
                          name="office_address"
                          value={form.office_address}
                          placeholder={strings.workLocation}
                          onChange={handleInputField}
                          autoComplete="off"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlLastName">
                          {strings.ethniCity}
                        </label>
                        <select
                          className="form-control digits"
                          id="formcontrol-select1"
                          name="ethnicity_id"
                          value={form.ethnicity_id}
                          onChange={(e) => {
                            var index = e.target.selectedIndex;
                            var ethnicity = e.target[index].text;
                            const nextFormState = {
                              ...form,
                              ethnicity_id: e.target.value,
                              ethnicity: ethnicity,
                            };
                            setForm(nextFormState);
                          }}
                        >
                          <option value={""}>{strings.selectEthnicity}</option>
                          {ethnicityList.length > 0 ? (
                            ethnicityList.map((item, i) => (
                              <option key={i} value={item._id}>
                                {item.title}
                              </option>
                            ))
                          ) : (
                            <option></option>
                          )}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-2">
                        <label htmlFor="visit_with">
                          {strings.visitingWith}
                        </label>
                        <div className="col-md-12 form-group m-t-3 m-checkbox-inline mb-0 custom-radio-ml">
                          {/* Family */}
                          <div className="radio radio-primary col-md-3">
                            <input
                              id="radio_family"
                              className="form-check-input"
                              type="radio"
                              name="visit_with"
                              value="family"
                              checked={form.visit_with === "family"}
                              onChange={handleInputField}
                            />
                            <label className="mb-0" htmlFor="radio_family">
                              {strings.family}
                            </label>
                          </div>

                          {/* Couple */}
                          <div className="radio radio-primary col-md-3 mt-1">
                            <input
                              id="radio_couple"
                              className="form-check-input"
                              type="radio"
                              name="visit_with"
                              value="couple"
                              checked={form.visit_with === "couple"}
                              onChange={handleInputField}
                            />
                            <label className="mb-0" htmlFor="radio_couple">
                              {strings.couple}
                            </label>
                          </div>

                          {/* Friend */}
                          <div className="radio radio-primary col-md-3 mt-1">
                            <input
                              id="radio_friend"
                              className="form-check-input"
                              type="radio"
                              name="visit_with"
                              value="friend"
                              checked={form.visit_with === "friend"}
                              onChange={handleInputField}
                            />
                            <label className="mb-0" htmlFor="radio_friend">
                              {strings.friend}
                            </label>
                          </div>

                          {/* Single */}
                          <div className="radio radio-primary col-md-3 mt-1">
                            <input
                              id="radio_single"
                              className="form-check-input"
                              type="radio"
                              name="visit_with"
                              value="single"
                              checked={form.visit_with === "single"}
                              onChange={handleInputField}
                            />
                            <label className="mb-0" htmlFor="radio_single">
                              {strings.single}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlLastName1">
                          {strings.occupation}
                        </label>
                        <select
                          id="occupationSelect"
                          name="occupation"
                          className="form-control"
                          value={form.occupation}
                          onChange={handleInputField}
                        >
                          <option value="">-- Select Occupation --</option>
                          <option value="salaried">{strings.salaried}</option>
                          <option value="business">{strings.business}</option>
                          <option value="professional">
                            {strings.professional}
                          </option>
                          <option value="retired">{strings.retired}</option>
                          <option value="home maker">
                            {strings.homeMaker}
                          </option>
                          <option value="self employee">
                            {strings.selfEmployed}
                          </option>
                          <option value="others">{strings.others}</option>
                        </select>
                        {/* </div> */}
                      </div>
                    </div>

                    <div className="col-md-12">
                      <h5 className="text-center pt-1">
                        {strings.propertyRequire}
                      </h5>
                    </div>

                    {selectedProperty && configurationsType.length > 0 && (
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label htmlFor="configurationSelect">
                            {strings.configuration}
                          </label>
                          <select
                            className="form-control digits"
                            id="configurationSelect"
                            name="configuration_id"
                            value={form.configuration_id || ""}
                            onChange={handleConfigurationSelect}
                          >
                            <option value={""}>
                              {strings.selectConfiguration}
                            </option>
                            {configurationsType.map((configuration, idx) => (
                              <option key={idx} value={configuration._id}>
                                {configuration.title}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    )} 

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlLastName1">
                          {strings.expectedPossessionPeriode}
                        </label>
                        <select
                          id="expected_possession_periodSelect"
                          name="expected_possession_period"
                          className="form-control"
                          value={form.expected_possession_period}
                          onChange={handleInputField}
                        >
                          <option value="">{strings.selectExpectedPossession}</option>
                          <option value="3 – 6 Months">{strings.three_to_six_month}</option>
                          <option value="6 Months – 1 Year">{strings.six_to_one_year}</option>
                          <option value="1 – 2 Years">
                            {strings.one_year_to_two_year}
                          </option>
                          <option value="2 Years and Above">{strings.two_year_and_above}</option>
                        </select>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlLastName1">
                          {strings.budgetAmount}
                        </label>
                        <select
                          id="budget_amountSelect"
                          name="budget_amount"
                          className="form-control"
                          value={form.budget_amount}
                          onChange={handleInputField}
                        >
                          <option value="">{strings.selectBudgetAmount}</option>
                          <option value="Below - 50L">{strings.below_50_lakhs}</option>
                          <option value="50L - 75L">{strings.fifty_lakhs_to_seventy_five_lakhs}</option>
                          <option value="75L - 1Cr">
                            {strings.seventy_five_lakhs_to_one_crore}
                          </option>
                          <option value="1Cr - 1.30Cr">{strings.one_crore_to_1_30_crore}</option>
                          <option value="1.31Cr - 1.50Cr">{strings.one_31_crore_to_1_50_crore}</option>
                          <option value="1.51Cr - 1.75Cr">{strings.one_51_crore_to_1_75_crore}</option>
                          <option value="1.76Cr - 2Cr">{strings.one_76_crore_to_2_crore}</option>
                          <option value="2Cr - 2.5Cr">{strings.two_crore_to_2_5_crore}</option>
                          <option value="2.5Cr and above">{strings.above_2_5_crore}</option>
                        </select>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlLastName">
                          {strings.Purpose}
                        </label>
                        <div
                          className="col-md-12 form-group m-t-5 m-checkbox-inline mb-0 custom-radio-ml"
                          style={{ padding: "0px" }}
                        >
                          <div className="radio radio-primary col-md-4">
                            <input
                              id="radioinline4"
                              type="radio"
                              name="purpose"
                              value={"end user"}
                              checked={
                                form.purpose === "end user" ? true : false
                              }
                              onChange={handleInputField}
                            />
                            <label className="mb-0" htmlFor="radioinline4">
                              {strings.endUser}
                            </label>
                          </div>
                          <div className="radio radio-primary col-md-4 mt-1">
                            <input
                              id="radioinline5"
                              type="radio"
                              name="purpose"
                              value={"invest"}
                              checked={form.purpose === "invest" ? true : false}
                              onChange={handleInputField}
                            />
                            <label className="mb-0" htmlFor="radioinline5">
                              {strings.invesment}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div className="row">
                    <div className="col-md-12 d-flex justify-content-end">
                      <div className="card-footer">
                        <button
                          className="btn btn-color"
                          type="button"
                          onClick={() => handleSubmit()}
                        >
                          {strings.submit}
                        </button>
                      </div>
                    </div>
                    {!isEmpty(formVaild) && (
                      <div className="col-md-12 float-right">
                        <span
                          style={{
                            color: "red",
                            float: "right",
                            padding: "5px 15px 25px 5px",
                          }}
                        >
                          {strings.fieldRequired}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {successPop && <div className="modal-backdrop fade show"></div>}
    </div>
  ) : (
    <div style={{ textAlign: "center" }}>
      <div className="page-wrapper">
        <div className="error-wrapper">
          <div className="container">
            <img className="img-100" src="/assets/images/sad.png" alt="" />
            <div className="error-heading">
              <h2 className="headline font-info">404</h2>
            </div>
            <div className="col-md-8 offset-md-2">
              <p className="sub-content">
                The page you are attempting to reach is currently not available.
                This may be because the page does not exist or has been moved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Lead;
